import { render, staticRenderFns } from "./ServiceFeeUpgradeModal.vue?vue&type=template&id=09cf79b2&scoped=true&"
import script from "./ServiceFeeUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeUpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeUpgradeModal.vue?vue&type=style&index=0&id=09cf79b2&lang=scss&scoped=true&"
import style1 from "./ServiceFeeUpgradeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf79b2",
  null
  
)

export default component.exports